var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackerPasoIncompleto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.815 18.6194C19.7886 18.6506 19.7742 18.692 19.746 18.725C19.0704 19.508 18.2802 20.1728 17.4102 20.729C17.2302 20.8442 17.1456 21.062 17.2026 21.2678L17.2386 21.398C17.337 21.7538 17.0172 22.0844 16.6584 21.998L14.3112 21.434C13.9866 21.356 13.836 20.9804 14.0178 20.6996L15.1998 18.872C15.3972 18.5672 15.8472 18.5792 16.0272 18.8948C16.1658 19.1378 16.4814 19.2134 16.7142 19.0592C18.7908 17.687 20.1924 15.3584 20.4426 12.8696C21.021 7.12517 15.8238 2.44397 10.1616 3.69377C8.9022 3.97217 7.6938 4.55597 6.6936 5.37017C6.4932 5.53337 6.1992 5.50877 6.0276 5.31617L5.48939 4.71317C5.30459 4.50557 5.3322 4.18637 5.5488 4.01177C6.9714 2.86397 8.6868 2.09117 10.5072 1.82777C17.2218 0.855167 22.9878 6.53057 22.1808 13.256C21.9384 15.2786 21.1146 17.0786 19.8156 18.6194H19.815Z",
    fill: "#C3C3C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6936 10.2374L2.031 9.80541C2.0052 9.79881 1.998 9.78261 1.995 9.75801C1.9848 9.66381 2.142 9.14781 2.1798 9.02121C2.451 8.11701 2.9112 7.11201 3.441 6.33141C3.4704 6.28821 3.609 6.08301 3.6432 6.08301L5.0616 7.09701C4.4052 8.04201 3.9348 9.11001 3.693 10.238L3.6936 10.2374Z",
    fill: "#C3C3C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5088 11.7164C3.4992 12.494 3.5718 13.2716 3.7566 14.0258L2.1192 14.7848C1.8438 13.7588 1.7124 12.6974 1.7508 11.6318L3.5082 11.7164H3.5088Z",
    fill: "#C3C3C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.146 15.1943C4.4574 16.0199 4.9356 16.7813 5.4966 17.4563L4.1772 18.6071C4.1232 18.6155 4.0284 18.4319 3.9966 18.3941C3.9324 18.3179 3.8532 18.2453 3.7896 18.1613C3.342 17.5679 2.9646 16.9061 2.6544 16.2311L4.146 15.1943Z",
    fill: "#C3C3C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3226 21.5814C7.4304 21.2676 6.6054 20.7798 5.847 20.22L6.8796 18.7764C7.3224 19.11 7.7958 19.4106 8.295 19.6536C8.5116 19.7592 8.7504 19.8396 8.9556 19.9566L8.3226 21.5808V21.5814Z",
    fill: "#C3C3C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3534 20.4978L12.888 22.236C11.9982 22.3194 11.091 22.2858 10.2144 22.1142L10.5336 20.373C11.1318 20.4948 11.7438 20.505 12.3534 20.4978Z",
    fill: "#C3C3C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2248C12.6767 13.2248 13.2252 12.6763 13.2252 11.9996C13.2252 11.323 12.6767 10.7744 12 10.7744C11.3233 10.7744 10.7748 11.323 10.7748 11.9996C10.7748 12.6763 11.3233 13.2248 12 13.2248Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerPasoIncompleto);
export default __webpack_public_path__ + "static/media/TrackerPasoIncompleto.0b9fc9ffffad8a4fb71a329b9c503d00.svg";
export { ForwardRef as ReactComponent };